import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import Modal from "../../../component/Global/Modal";
import DisplayQtyMinQtyMult from "../../../component/Product/DisplayQtyMinQtyMult";
import CartRepository from '../../../repository/CartRepository';
import moment from 'moment'
import { useForm } from 'react-hook-form';
import PlusMinusInputWithDebounce from "../../../component/PlusMinusInputWithDebounce";
import { isArray } from "underscore";
import { DatePicker } from 'rsuite';
import Helper from 'src/support/Helper';

// Note: If update anything for this component Please make sure update the same for the QuoteDateSchedulePopup

const DateSchedulePopup = (props) => {
    const [status, SetStatus] = useState(false);
    const [loader, setLoader] = useState(false);
    const [final_validated, set_final_validated] = useState(false);
    const [shipmentDetailValidation, setShipmentDetailValidation] = useState([]);
    const buttonRef = useRef();
    const { CART_PRODUCT_DATA } = props.data;
    const { single_product_inventory } = props.data;
    const { CART_DATA_SINGLE } = props.data;

    const [shipmentDetail, setShipmentDetail] = useState([]);

    const [minSelectDate, setMinSelectDate] = useState('')
    const [maxSelectDate, setMaxSelectDate] = useState('')
    const [isOpen, setIsOpen] = useState('');

    let currentDate = moment().format('YYYY-MM-DD');
    let AfterWeek = moment(currentDate).add(7, 'd').format('YYYY-MM-DD')
    let beforeYear = moment(currentDate).add(1, 'Y').format('YYYY-MM-DD');
    useEffect(() => {
        async function fetchHere() {
            if (CART_DATA_SINGLE !== undefined && CART_DATA_SINGLE && CART_DATA_SINGLE.scheduleDetails) {
                SetStatus(true)
            }
            await getAllData()
        }

        fetchHere()
    }, [CART_DATA_SINGLE]);

    useEffect(() => {
        async function fetchHere() {
            await maintainValidation(shipmentDetail)
        }

        fetchHere()
    }, [shipmentDetail]);
    const onHide = (action = true) => {
        SetStatus(false)
    };

    const getAllData = async () => {
        setMinSelectDate(AfterWeek)
        setMaxSelectDate(beforeYear)
        if (CART_DATA_SINGLE.scheduleDetails && CART_DATA_SINGLE.scheduleDetails.length === 0) {
            setShipmentDetail([{
                shipmentId: '',
                quantity: CART_PRODUCT_DATA.QtyMin,
                scheduledDate: AfterWeek
            }]);
        }
        if (CART_DATA_SINGLE.scheduleDetails && CART_DATA_SINGLE.scheduleDetails.length > 0) {
            setShipmentDetail(CART_DATA_SINGLE.scheduleDetails)
        }
    }
    const maintainValidation = async (shipmentDetail) => {
        let v_a = [];
        if (isArray(shipmentDetail) && shipmentDetail.length > 0) {
            let validateDateValueBasedOnAllSelectedDateData = validateDateValueBasedOnAllSelectedDate();
            shipmentDetail.map((v, i) => {
                let scheduledDate = [];
                let quantity = [];
                let v_a_i = {};
                if (!v.scheduledDate) {
                    scheduledDate.push('Scheduled Date Required');
                }
                if (v.scheduledDate && validateDateValue(v.scheduledDate) === false) {
                    scheduledDate.push('Orders cannot be scheduled sooner than 7 days or later than 12 months from order date.');
                }
                if (v.scheduledDate) {
                    let r_v = validateDateValueBasedOnNextAndPrevious(v, i, validateDateValueBasedOnAllSelectedDateData);
                    if (r_v.status === false) {
                        scheduledDate.push('Based on previous date ' + moment(r_v.previous_data, 'YYYY-MM-DD').format('DD-MM-YYYY') + ' there should be ’7 days’ gap.');
                    }
                }
                if (v.scheduledDate && validateDateValueBasedOnAllSelectedDate(v.scheduledDate) === false) {
                }
                if (validateQuantityValue(v.quantity) === false) {
                    quantity.push('Quantity Failed');
                }
                if (validateQuantityOnModuloValue(v.quantity) === false || validateQuantityOnMinValue(v.quantity) === false
                    || (!v.quantity || v.quantity === 0)) {
                    quantity.push('Invalid Quantity');
                }
                if (validateQuantityValueOnTotalValue(i) === false) {
                    quantity.push('User cannot schedule more than the order quantity selected.');
                }
                if (quantity.length > 0) {
                    v_a_i.quantity = quantity;
                }
                if (scheduledDate.length > 0) {
                    v_a_i.scheduledDate = scheduledDate;
                }
                if (Object.entries(v_a_i).length > 0) {
                    v_a[i] = v_a_i
                }
            });
        }
        setShipmentDetailValidation(v_a);
        if (v_a.length > 0) {
            set_final_validated(false);
        }
        if (v_a.length === 0) {
            set_final_validated(true);
        }
    };

    const validateDateValue = (date_value) => {
        return validateScheduleDateError(date_value) !== false;
    };
    const validateDateValueBasedOnNextAndPrevious = (currentValue, currentIndex, validateDateValueBasedOnAllSelectedDateData) => {
        if (validateDateValueBasedOnAllSelectedDateData[currentIndex] !== undefined) {
            let r_v = validateDateValueBasedOnAllSelectedDateData[currentIndex];
            if (currentValue.scheduledDate === r_v.previous) {
                return {
                    status: true,
                    previous_data: r_v.previous
                };
            }
            return {
                status: validateScheduleDateError(currentValue.scheduledDate, r_v.previous),
                previous_data: r_v.previous
            };
        }
        return {
            status: false,
            previous_data: currentValue.scheduledDate
        };
    }
    const validateDateValueBasedOnAllSelectedDate = () => {
        let s = {};
        if (isArray(shipmentDetail) && shipmentDetail.length > 0) {
            shipmentDetail.map((v, i) => {
                let m_u = moment(v.scheduledDate, 'YYYY-MM-DD').unix();
                s[m_u] = {
                    value: v,
                    unix_time_stamp: m_u,
                    scheduler_index: i
                };
            });
        }
        let s_f = Object.keys(s).sort().reduce(
            (obj, key) => {
                obj[key] = s[key];
                return obj;
            },
            {}
        );
        let shipmentDetail_state_array = [];
        if (Object.entries(s_f).length > 0) {
            let keyMakerHere = 0;
            Object.entries(s_f).map(s_f_value => {
                shipmentDetail_state_array[keyMakerHere] = s_f_value[1];
                keyMakerHere++;
            })
        }
        let shipmentDetail_state = [];
        if (shipmentDetail_state_array.length > 0) {
            shipmentDetail_state_array.map((s_f_value, s_f_index) => {
                let v_h = s_f_value;
                if (s_f_index === 0 && shipmentDetail_state_array[0] !== undefined) {
                    v_h.previous = shipmentDetail_state_array[0].value.scheduledDate;
                }
                if (s_f_index > 0 && shipmentDetail_state_array[s_f_index - 1] !== undefined) {
                    v_h.previous = shipmentDetail_state_array[s_f_index - 1].value.scheduledDate;
                }
                if (s_f_index === 0 && shipmentDetail_state_array[0] !== undefined) {
                    v_h.next = shipmentDetail_state_array[0].value.scheduledDate;
                } else {
                    if (s_f_index === (shipmentDetail_state_array.length - 1)) {
                        v_h.next = shipmentDetail_state_array[shipmentDetail_state_array.length - 1].value.scheduledDate;
                    }
                    if (s_f_index !== (shipmentDetail_state_array.length - 1)) {
                        v_h.next = shipmentDetail_state_array[s_f_index + 1].value.scheduledDate;
                    }
                }
                shipmentDetail_state[s_f_value.scheduler_index] = v_h;
            })
        }
        return shipmentDetail_state;
    };
    const validateQuantityOnModuloValue = (quantity_value) => {
        return quantity_value % CART_PRODUCT_DATA.QtyMult === 0;
    };
    const validateQuantityOnMinValue = (quantity_value) => {
        if (quantity_value < CART_PRODUCT_DATA.QtyMin) {
            return false
        }
    };
    const validateQuantityValue = (quantity_value) => {
        return true;
    };
    const validateScheduleDateError = (date, dateObject = false) => {
        if (!dateObject) {
            dateObject = currentDate
        }
        if (dateObject === false) {
            return false;
        }
        let selectedDate = moment(date).format('YYYY-MM-DD');
        if (selectedDate <= moment(dateObject).add(6, 'd').format('YYYY-MM-DD')) {
            return false
        } else if (selectedDate >= beforeYear) {
            return false
        }
        let prevDate = '';
        if (prevDate === '') {
            prevDate = selectedDate;
        } else {
            let shipmentDay = moment.duration(moment(selectedDate).diff(moment(prevDate))).asDays();
            if (shipmentDay < 7) {
                return false;
            } else {
                prevDate = selectedDate;
            }
        }
        return prevDate;
    };
    const validateQuantityValueOnTotalValue = (itemNo) => {
        let totalQuantity = 0;
        if (isArray(shipmentDetail) && shipmentDetail.length > 0) {
            shipmentDetail.map((v, i) => {
                if (itemNo >= i) {
                    totalQuantity = totalQuantity + v.quantity;
                }
            });
        }
        if (totalQuantity > CART_DATA_SINGLE.quantity) {
            return false;
        }
        return true;
    };

    const handleChange = (i, e) => {
        const { name, value } = e.target;
        let newShipment = JSON.parse(JSON.stringify(shipmentDetail));
        if (name.includes('quantity')) {
            newShipment[i]['quantity'] = value;
        }
        if (name.includes('scheduledDate')) {
            newShipment[i]['scheduledDate'] = value;
        }
        setShipmentDetail(newShipment);
    }

    const addShipment = () => {
        let AfterWeekHere = AfterWeek;
        let validateDateValueBasedOnAllSelectedDateData = validateDateValueBasedOnAllSelectedDate();
        if (isArray(validateDateValueBasedOnAllSelectedDateData) && validateDateValueBasedOnAllSelectedDateData.length &&
            validateDateValueBasedOnAllSelectedDateData[validateDateValueBasedOnAllSelectedDateData.length - 1] !== undefined) {
            let validObject = validateDateValueBasedOnAllSelectedDateData[validateDateValueBasedOnAllSelectedDateData.length - 1];
            if (validObject.value !== undefined && validObject.value.scheduledDate !== undefined) {
                AfterWeekHere = validObject.value.scheduledDate;
                if (AfterWeekHere) {
                    AfterWeekHere = moment(AfterWeekHere).add(7, 'd').format('YYYY-MM-DD');
                }
            }
        }
        setShipmentDetail([...shipmentDetail, {
            shipmentId: '',
            quantity: CART_PRODUCT_DATA.QtyMin,
            scheduledDate: AfterWeekHere
        }])
    }

    const removeShipment = (i) => {
        let newShipment = [...shipmentDetail];
        newShipment.splice(i, 1);
        setShipmentDetail(newShipment)
    }

    const { register, handleSubmit, formState: { errors }, clearErrors } = useForm();
    const onSubmit = async (data) => {
        setLoader(true)
        await maintainValidation(shipmentDetail);
        if (final_validated === false) {
            return false;
        }

        await new CartRepository().scheduleShippingApply(
            {
                "cartDetailId": CART_DATA_SINGLE.cartDetailId,
                "scheduleDetails": shipmentDetail
            }
        );
        setLoader(false)
        onHide()
    }

    return (
        <>
            <Modal show={status} onHide={() => {
                onHide()
            }}>
                <div className="avnet-modal modal-800" id="sceduledate" style={{ overflow: 'unset' }}>
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×
                        </button>
                        <div className="modal-header">
                            <h3 className="modal-title mx-auto" id="exampleModalLongTitle">Schedule Shipments</h3>
                        </div>
                        <div className={`modal-body${isOpen && ' overflow-visible'}`}>
                            <form id="hook-form">
                                <div>
                                    {single_product_inventory &&
                                        single_product_inventory.quantity !== undefined &&
                                        <p><b>{single_product_inventory.quantity} Ships as available </b></p>
                                    }
                                    <p>Scheduled up to 12 months in advanced.</p>
                                    <p>Shipping charges apply to each shipment.</p>
                                </div>
                                {shipmentDetail && shipmentDetail.map((element, index) => (
                                    <div key={index} className="d-flex pt-3 pb-2">
                                        <div className="me-3 maxw240">
                                            <PlusMinusInputWithDebounce
                                                disable_validation_check={true}
                                                name={"quantity-" + index} type="text"
                                                className="form-control form-control-sm input-number bg-white"
                                                QtyMult={CART_PRODUCT_DATA.QtyMult}
                                                // Author : Trilok  Date: 9/2/2023 Reason: display selected quantity instead of min qty
                                                force_default_quantity={element.quantity > 0 ? element.quantity : (CART_PRODUCT_DATA.QtyMin > 0 ? CART_PRODUCT_DATA.QtyMin : 0)}
                                                onChange={(value) => {
                                                    handleChange(index, {
                                                        target: {
                                                            'name': "quantity-" + index,
                                                            value
                                                        }
                                                    });
                                                }}
                                            />

                                            <div className="text-start small-text light light-text collapse_minmax">
                                                <DisplayQtyMinQtyMult
                                                    single_product={CART_PRODUCT_DATA} /></div>
                                            {shipmentDetailValidation[index] !== undefined &&
                                                shipmentDetailValidation[index]['quantity'] !== undefined &&
                                                shipmentDetailValidation[index]['quantity'].map((v) => (
                                                    <p className="error"
                                                        dangerouslySetInnerHTML={{ __html: v }} />
                                                ))
                                            }
                                        </div>
                                        <div className="model-time-picker minw240">
                                            <div style={{ position: 'relative' }}>
                                                <div id={"date-picker-container-" + index} />
                                                <DatePicker
                                                    container={() => document.getElementById("date-picker-container-" + index)}
                                                    placeholder="Date select"
                                                    onFocus={(e) => setIsOpen(true)}
                                                    onSelect={(date, event) => {
                                                        // Author: Trilok 
                                                        // Reason : fixed issue of date change to 1 day back 
                                                        // Date: 14/02/2023
                                                        handleChange(index, { target: { name: "scheduledDate", value: moment(date).format('YYYY-MM-DD') } })
                                                    }}
                                                    oneTap
                                                    name="scheduledDate"
                                                    value={moment(element.scheduledDate).toDate()}
                                                    cleanable={false}
                                                    format={Helper.getDatepickerFormat()}
                                                    editable={false}
                                                    className="w-100"
                                                    placement='bottomStart'
                                                />
                                            </div>
                                            {
                                                index >= 0 ?
                                                    <div className="d-block text-end mt-2">
                                                        <a className='text-blue2' onClick={() => removeShipment(index)}><b>Remove</b></a>
                                                    </div>
                                                    : null
                                            }
                                            {shipmentDetailValidation[index] !== undefined &&
                                                shipmentDetailValidation[index]['scheduledDate'] !== undefined &&
                                                shipmentDetailValidation[index]['scheduledDate'].map((v) => (
                                                    <p className="error">{v}</p>
                                                ))
                                            }
                                        </div>
                                    </div>
                                ))}
                            </form>
                        </div>
                        <div className="modal-footer text-center">
                            <button disabled={loader} className="bs5 btn btn-secondary btn-sm w80" data-dismiss="modal"
                                onClick={() => {
                                    onHide()
                                }}>cancel
                            </button>
                            <button disabled={!final_validated || loader ? true : false} type="button" ref={buttonRef}
                                className="bs5 btn btn-primary btn-sm w140"
                                onClick={() => addShipment()}> ADD A SHIPMENT
                            </button>
                            {
                                loader ?
                                    <button disabled={!final_validated || loader ? true : false} type="submit" className="bs5 btn btn-primary btn-sm w140" form="hook-form">
                                        <i className="fa fa-spinner fa-spin" />
                                    </button>
                                    :
                                    <button disabled={!final_validated || loader ? true : false} type="submit" className="bs5 btn btn-primary btn-sm w140" form="hook-form" onClick={handleSubmit(onSubmit)}>
                                        Apply
                                    </button>
                            }
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default DateSchedulePopup;